import Interpolate from '@engined/client/components/Interpolate.js';
import { useLocale } from '@engined/client/contexts/LocaleContext.js';
import { CLIENT_ERROR_SNACKBAR_CONTENT, CLIENT_ERROR_SNACKBAR_TITLE } from '@engined/client/locales.js';
import { Typography } from '@mui/material';
import React from 'react';

interface OwnProps {
  className?: string;
}

type Props = OwnProps;

const ServerErrorSnackbar: React.FunctionComponent<Props> = ({ className }) => {
  const { t } = useLocale();
  return (
    <div className={className}>
      <Typography variant="h6" component="h6">
        {t(CLIENT_ERROR_SNACKBAR_TITLE)}
      </Typography>
      <Interpolate resource={CLIENT_ERROR_SNACKBAR_CONTENT} />
    </div>
  );
};

ServerErrorSnackbar.displayName = 'ServerErrorSnackbar';

export default React.memo<Props>(ServerErrorSnackbar);
